import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("qwj_cookie_ok")) setShow(true);
  }, []);
  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-50 p-3 sm:p-4">
      <div className="mx-auto max-w-3xl card-surface rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 gold-glow">
        <p className="text-sm text-white/75 flex-1">
          We use cookies to make the site work and understand what's helpful. See our{" "}
          <Link to="/legal/privacy" className="text-[#D4AF37] underline">Privacy Policy</Link>.
        </p>
        <button
          data-testid="cookie-accept-btn"
          onClick={() => { localStorage.setItem("qwj_cookie_ok", "1"); setShow(false); }}
          className="rounded-full bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] px-5 py-2 text-sm font-semibold text-[#0A0A0A] whitespace-nowrap"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
